// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGINAS: '/auth/login-as',
    SIGNUP: '/auth/register',
    FORGOT: '/auth/forgot-password',
    CHECKHASH: '/auth/check-hash',
    SETPASSWORD: '/auth/change-password-with-hash',
    ADDTENANTDETAILS: '/auth/add-tenant-details',



    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    PROFILE: '/auth/profile',
  },
  USERS: {
    LIST: '/auth/api/users',
    CREATE: '/auth/api/users',
    UPDATE: (id: string) => `/auth/api/users/${id}`,
    DELETE: (id: string) => `/auth/api/users/${id}`,
    DETAILS: (id: string) => `/auth/api/users/${id}`,
  },

  DEPARTMENTS: {
    LIST: '/auth/api/departments',
    CREATE: '/auth/api/departments',
    UPDATE: (id: string) => `/auth/api/departments/${id}`,
    DELETE: (id: string) => `/auth/api/departments/${id}`,
    DETAILS: (id: string) => `/auth/api/departments/${id}`,
  },
  CLIENT: {
    GET_BY_ID: (id: string) => `/core/client/${id}`,
    LIST: '/core/clients',
  },
  TENANT: {
    LIST: '/auth/api/tenants',
    DETAIL: (id: string) => `/auth/api/tenants/${id}`,
    UPDATE: (id: string) => `/auth/api/tenants/${id}`,
  },
  AGENTS: {
    LIST: '/core/agent-types',
    CREATE: '/core/agent-types',
    UPDATE: (id: string) => `/core/agent-types/${id}`,
    DELETE: (id: string) => `/core/agent-types/${id}`,
    DETAILS: (id: string) => `/core/agent-types/${id}`,
  },

  AGENT_INSTANCES: {
    CREATE: "/core/agent-instances",
    GET_BY_ID: (id: string) => `/core/agent-instances/${id}`,
    LIST: "/core/agent-instances",
    UPDATE: (id: string) => `/core/agent-instances/${id}`,
    UPDATEAISETTINGS: (id: string) => `/core/agent-instances/${id}/ai-settings`,
    DELETE: (id: string) => `/core/agent-instances/${id}`,
    RESTORE: (id: string) => `/api/agent-instances/${id}/restore`,

    ACTIONS: {
      CREATE: (id: string) => `/core/agent-instances/${id}/actions`,
      LIST: (id: string) => `/core/agent-instances/${id}/actions`,
      GET: (id: string, actionId: string) => `/core/agent-instances/${id}/actions/${actionId}`,
      UPDATE: (id: string, actionId: string) => `/core/agent-instances/${id}/actions/${actionId}`,
      DELETE: (id: string, actionId: string) => `/core/agent-instances/${id}/actions/${actionId}`,
      RESTORE: (id: string, actionId: string) => `/core/agent-instances/${id}/actions/${actionId}/restore`,
    },

    INTEGRATION: {
      CREATE: (id: string) => `/core/agent-instances/${id}/integrations`,
      UPDATE: (id: string, integrationId: string) => `/core/agent-instances/${id}/integrations/${integrationId}`,
      LIST: (id: string) => `/core/agent-instances/${id}/integrations`,
    },

    MCP_INTEGRATIONS: {
      LIST: (id: string) => `/core/agent-instances/${id}/mcp-integrations`,
      CONNECT: (id: string, serverId: string) => `/core/agent-instances/${id}/mcp-integrations/${serverId}/connect`,
      DISCONNECT: (id: string, serverId: string) => `/core/agent-instances/${id}/mcp-integrations/${serverId}/disconnect`,
      OAUTH_START: (id: string, serverId: string) => `/core/agent-instances/${id}/mcp-integrations/${serverId}/oauth/start`,
      TOOLS: (id: string, serverId: string) => `/core/agent-instances/${id}/mcp-integrations/${serverId}/tools`,
    },

    DOCUMENTS: {
      LIST: (id: string) => `/core/agent-instances/${encodeURIComponent(id)}/documents`,
      TRAIN_DOCUMENT: (id: string, docId: string) => `/core/agent-instances/${id}/train-document/${docId}`,
      DELETE_DOCUMENT: (id: string, docId: string) => `/core/agent-instances/${id}/documents/${docId}`,
    },

    DB_CONFIG: {
      GET: (id: string) => `/core/agent-db-config/${id}`,
      CREATE: () => `/core/agent-db-config`,
      UPDATE: (id: string) => `/core/agent-db-config/${id}`,
    },
  },

  UPLOADS: {
    LIST: '/core/uploads',
    CREATE: '/core/uploads',
    UPDATE: (id: string) => `/core/agent-instances/${id}/documents`,
    GETONE: (id: string) => `/core/uploads/url/${id}`
  },
  QA: {
    CREATE: '/core/qa-pairs',
    LIST: '/core/qa-pairs',
    TRAIN: '/core/qa-pairs/train',
    UPDATE: (id: string) => `/core/qa-pairs/${id}`,
    DELETE: (id: string) => `/core/qa-pairs/${id}`,
  },
  CHATBOT_ECOSYSTEM_QA: {
    CREATE: '/core/chatbot-ecosystem-qa-pairs',
    LIST: '/core/chatbot-ecosystem-qa-pairs',
    TRAIN: '/core/chatbot-ecosystem-qa-pairs/train',
    GET: (id: string) => `/core/chatbot-ecosystem-qa-pairs/${id}`,
    UPDATE: (id: string) => `/core/chatbot-ecosystem-qa-pairs/${id}`,
    DELETE: (id: string) => `/core/chatbot-ecosystem-qa-pairs/${id}`,
    RESTORE: (id: string) => `/core/chatbot-ecosystem-qa-pairs/${id}/restore`,
  },
  CONAUDIT: {
    CREATE: '/core/conversation-audit',
    LIST: '/core/conversation-audit',
    UPDATE: (id: string) => `/core/conversation-audit/${id}`,
    DELETE: (id: string) => `/core/conversation-audit/${id}`,
  },
  CHATBOTS: {
    CREATE: "/core/chatbots",
    GET_BY_ID: (id: string) => `/core/chatbots/${id}`,
    GENERATE_CODE_SCRIPT: (id: string) => `/core/generate-code-script/${id}`,
    LIST: "/core/chatbots",
    UPDATE: (id: string) => `/core/chatbots/${id}`,
    UPDATETHEME: (id: string) => `/core/chatbots/${id}/theme-settings`,
    DELETE: (id: string) => `/core/chatbots/${id}`,
    RESTORE: (id: string) => `/core/chatbots/${id}/restore`,
  },
  CHATBOT_NOTIFICATIONS: {
    DEPARTMENTS: (chatbotId: string) => `/core/chatbot-notifications/departments/${chatbotId}`,
    CREATE_DEPARTMENT: `/core/chatbot-notifications/departments`,
    UPDATE_DEPARTMENT: (id: string) => `/core/chatbot-notifications/departments/${id}`,

    STAFF: (chatbotId: string) => `/core/chatbot-notifications/staff/${chatbotId}`,
    CREATE_STAFF: `/core/chatbot-notifications/staff`,
    UPDATE_STAFF: (id: string) => `/core/chatbot-notifications/staff/${id}`,
  },
  CHAT: {
    SEND_MESSAGE: '/core/chat/send-message',
    SYNC_TENANT_USER_PROFILE: '/core/chat/sync-tenant-user-profile',
  },
  MCP: {
    OAUTH_COMPLETE: '/core/mcp/oauth/complete',
    SERVERS: {
      CREATE: '/core/mcp/servers',
      LIST: '/core/mcp/servers',
      GET: (serverId: string) => `/core/mcp/servers/${serverId}`,
      UPDATE: (serverId: string) => `/core/mcp/servers/${serverId}`,
      DISCOVER: (serverId: string) => `/core/mcp/servers/${serverId}/discover`,
      VALIDATE: (serverId: string) => `/core/mcp/servers/${serverId}/validate`,
      TOOLS: (serverId: string) => `/core/mcp/servers/${serverId}/tools`,
    },
  },
  AGENT_TENANT:{
    CREATE: '/core/agent-tenant-map',
    LIST: '/core/agent-tenant-map',
    LIST_TENANTS: '/core/tenant-agent-map/list-tenant'
  },
  DEPARTMENT: {
    CREATE: "/core/agent-instances",
    GET_BY_ID: (id: string) => `/api/agent-instances/${id}`,
    LIST: "/core/departments",
    UPDATE: (id: string) => `/core/agent-instances${id}`,
    DELETE: (id: string) => `/core/agent-instances${id}`,
    RESTORE: (id: string) => `/api/agent-instances/${id}/restore`,
  },


  DASHBOARD: {
    METRICS: '/api/dashboard/metrics',
    CHARTS: '/api/dashboard/charts',
    ACTIVITIES: '/api/dashboard/activities',
  },
  REPORTS: {
    LIST: '/api/reports',
    GENERATE: '/api/reports/generate',
    DOWNLOAD: (id: string) => `/api/reports/${id}/download`,
  },
  VOICE: {
    ELEVENLABS_VOICES: '/core/ecosystem/voice/elevenlabs-voices',
  },
  ECOSYSTEMS: {
    LIST: '/core/ecosystems',
    CREATE: '/core/ecosystems',
    GET_BY_ID: (id: string) => `/core/ecosystems/${id}`,
    UPDATE: (id: string) => `/core/ecosystems/${id}`,
    DELETE: (id: string) => `/core/ecosystems/${id}`,
    ENTRY_AGENTS: {
      ADD: (id: string) => `/core/ecosystems/${id}/entry-agents`,
      REMOVE: (ecosystemId: string, agentInstanceId: string) => `/core/ecosystems/${ecosystemId}/entry-agents/${agentInstanceId}`,
      UPDATE_CONFIG: (ecosystemId: string, agentInstanceId: string) => `/core/ecosystems/${ecosystemId}/entry-agents/${agentInstanceId}/config`,
    },
    FUNCTIONAL_AGENTS: {
      ADD: (id: string) => `/core/ecosystems/${id}/functional-agents`,
      REMOVE: (ecosystemId: string, agentInstanceId: string) => `/core/ecosystems/${ecosystemId}/functional-agents/${agentInstanceId}`,
    },
    CONVERSATIONS: '/core/conversation-history',
    CONVERSATION_BY_ID: (id: string) => `/core/conversation-history/${id}`,
    CHAT: '/core/ecosystem/chat/send-message',
  },
  WORKFLOWS: {
    LIST: '/core/workflows',
    CREATE: '/core/workflows',
    GET_BY_ID: (id: string) => `/core/workflows/${id}`,
    UPDATE: (id: string) => `/core/workflows/${id}`,
    DELETE: (id: string) => `/core/workflows/${id}`,
    AGENTS: {
      ENTRY: '/core/workflows/agent-instances/entry',
      FUNCTIONAL: '/core/workflows/agent-instances/functional',
    },
    VOICE: {
      LEADS_PENDING: '/core/workflows/voice/leads/pending',
      LEAD_CALL: (leadId: string) => `/core/workflows/voice/leads/${leadId}/call`,
    },
  },
} as const;

// Application Constants
export const APP_CONFIG = {
  NAME: 'Agentic Platform',
  VERSION: '1.0.0',
  DESCRIPTION: 'A comprehensive dashboard for insurance, financial and healthcare industries',
  COMPANY: '',
  TAGLINE: 'END-TO-END CONVERGENCE',
  SUPPORT_EMAIL: 'support@domain.com',
  DOCUMENTATION_URL: 'https://docs.domain.com',
} as const;

// Navigation Configuration
export const NAVIGATION_ITEMS = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    href: '/dashboard',
    icon: 'ChartBarIcon',
  },
  {
    id: 'analytics',
    label: 'Analytics',
    href: '/analytics',
    icon: 'ChartPieIcon',
  },
  {
    id: 'reports',
    label: 'Reports',
    href: '/reports',
    icon: 'DocumentTextIcon',
  },
  {
    id: 'users',
    label: 'Users',
    href: '/users',
    icon: 'UsersIcon',
  },
  {
    id: 'settings',
    label: 'Settings',
    href: '/settings',
    icon: 'CogIcon',
  },
] as const;

// Theme Configuration
export const THEME_CONFIG = {
  colors: {
    primary: '#1e3a8a',
    secondary: '#3b82f6',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    info: '#8b5cf6',
  },
  fonts: {
    primary: 'Inter',
    secondary: 'JetBrains Mono',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
  },
} as const;

// Form Validation Rules
export const VALIDATION_RULES = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD: {
    MIN_LENGTH: 8,
    REQUIRE_UPPERCASE: true,
    REQUIRE_LOWERCASE: true,
    REQUIRE_NUMBER: true,
    REQUIRE_SPECIAL: true,
  },
  PHONE: /^\+?[\d\s\-\(\)]+$/,
  URL: /^https?:\/\/.+/,
} as const;

// Table Configuration
export const TABLE_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
  SORT_DIRECTIONS: ['asc', 'desc'] as const,
} as const;

// Notification Configuration
export const NOTIFICATION_CONFIG = {
  DEFAULT_DURATION: 5000,
  MAX_NOTIFICATIONS: 5,
  POSITIONS: ['top-right', 'top-left', 'bottom-right', 'bottom-left'] as const,
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_PREFERENCES: 'agentic_user_preferences',
  THEME: 'agentic_theme',
  SIDEBAR_STATE: 'agentic_sidebar_state',
  DASHBOARD_LAYOUT: 'agentic_dashboard_layout',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied.',
  NOT_FOUND: 'The requested resource was not found.',
  SERVER_ERROR: 'Internal server error. Please try again later.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  UNKNOWN_ERROR: 'An unexpected error occurred.',
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  SAVED: 'Changes saved successfully.',
  CREATED: 'Item created successfully.',
  UPDATED: 'Item updated successfully.',
  DELETED: 'Item deleted successfully.',
  EXPORTED: 'Data exported successfully.',
  IMPORTED: 'Data imported successfully.',
} as const;

// Loading States
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

// User Roles
export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  GUEST: 'guest',
} as const;

// Permission Levels
export const PERMISSIONS = {
  READ: 'read',
  WRITE: 'write',
  DELETE: 'delete',
  ADMIN: 'admin',
} as const;

// Date Formats
export const DATE_FORMATS = {
  SHORT: 'MMM dd, yyyy',
  LONG: 'MMMM dd, yyyy',
  DATETIME: 'MMM dd, yyyy HH:mm',
  TIME: 'HH:mm',
  ISO: 'yyyy-MM-dd',
} as const;

// File Upload Configuration
export const FILE_UPLOAD_CONFIG = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'text/csv'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.pdf', '.csv'],
} as const;

// Chart Configuration
export const CHART_CONFIG = {
  COLORS: {
    PRIMARY: '#1e3a8a',
    SECONDARY: '#3b82f6',
    SUCCESS: '#10b981',
    WARNING: '#f59e0b',
    ERROR: '#ef4444',
    INFO: '#8b5cf6',
  },
  GRID_COLOR: '#e5e7eb',
  TEXT_COLOR: '#6b7280',
  FONT_SIZE: 12,
  FONT_FAMILY: 'Inter, sans-serif',
} as const;
